import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SInput } from '@strana-artw/ui-kit';
import { email, required } from '@vuelidate/validators';
import { VALIDATION_INJECTION_KEY } from '@/shared/composables';
import { resolveFieldError } from './resolveFieldError';
export default {
  name: 'FormFieldEmail',
  components: {
    SInput: SInput
  },
  inject: {
    validation: VALIDATION_INJECTION_KEY
  },
  props: {
    field: {
      type: String,
      default: 'email'
    },
    autocomplete: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialValue: {
      type: String,
      default: ''
    },
    inlineConfirmation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    errorMessage: function errorMessage() {
      var _this$validation$$v;
      return resolveFieldError((_this$validation$$v = this.validation.$v) === null || _this$validation$$v === void 0 ? void 0 : _this$validation$$v[this.field], _objectSpread(_objectSpread({}, this.required && {
        required: 'Введите email'
      }), {}, {
        email: 'Введите корректный email',
        serverError: this.validation.serverErrors[this.field] || 'Ошибка на сервере'
      })) || undefined;
    },
    isEditing: function isEditing() {
      return !this.disabled && this.inlineConfirmation;
    }
  },
  created: function created() {
    var field = this.field,
      validation = this.validation;
    var validators = {
      email: email,
      serverError: function serverError() {
        return !validation.serverErrors[field];
      }
    };
    if (this.required) {
      validators.required = required;
    }
    this.$set(this.validation.validators.form, field, validators);
    this.$set(validation.form, field, this.initialValue);
  },
  beforeDestroy: function beforeDestroy() {
    this.$delete(this.validation.form, this.field);
    this.$delete(this.validation.validators.form, this.field);
  },
  methods: {
    clearServerError: function clearServerError() {
      if (this.validation.serverErrors[this.field]) {
        this.$delete(this.validation.serverErrors, this.field);
      }
    }
  }
};